import ImmersionContainer from 'components/Immersion/ImmersionContainer'
import ImmersionPresentation from 'components/Immersion/ImmersionPresentation'

export default {
  Container: ImmersionContainer,
  Presentation: ImmersionPresentation,
}
